import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7drubfti: FaireBrandEntity = {
  token: "b_7drubfti",
  type: "brand",
  name: "Julie Peach",
  avatarUrl:
    "https://cdn.faire.com/fastly/6ab403cc8239695c5930fe3a1052e3076adf1ea84c24de8e2a609b435619e257.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6f32db6aed7213e419d62b90594f32f28a025d1c9f506c19fd17241016820013.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6ab403cc8239695c5930fe3a1052e3076adf1ea84c24de8e2a609b435619e257.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6f32db6aed7213e419d62b90594f32f28a025d1c9f506c19fd17241016820013.jpeg",
  location: "Denver, CO, USA",
  minimumOrderDollars: 125,
  rating: 4.9,
  reviewCount: 33,
  isInsider: true,
  description:
    "I utilize traditional block printing techniques to create playful illustrations that I hope will make you smile. I believe products should make you feel good and leave the earth feeling good too, which is why I work with Denver's ONLY Green-Certified print shop for the silkscreened tea towels.\nAll pillow cases have been hand block printed in my Denver studio, and holiday stockings have been printed in collaboration with a fair-wage workshop in India!",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:07.304Z",
    importedBy: "entity-db-cli",
  },
};
